import * as React from 'react';

function SvgUsers(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 40 41"
            fill="none"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 15.895a5 5 0 1110 0 5 5 0 01-10 0zm5-3a3 3 0 100 6 3 3 0 000-6zm6.031-1.118a1 1 0 011.217-.72 5 5 0 010 9.687 1 1 0 11-.496-1.938 3 3 0 000-5.812 1 1 0 01-.72-1.217zM8 27.895a5 5 0 015-5h8a5 5 0 015 5v2a1 1 0 01-2 0v-2a3 3 0 00-3-3h-8a3 3 0 00-3 3v2a1 1 0 01-2 0v-2zm19.032-4.12a1 1 0 011.218-.718A5 5 0 0132 27.895v2a1 1 0 01-2 0v-1.999a3 3 0 00-2.25-2.902 1 1 0 01-.718-1.219z"
                fill="#8492A6"
            />
        </svg>
    );
}

export default SvgUsers;
